import '../../css/base.css';

const Kintail = () => {

  return (
    <div>
      <h2 className="walks-section-heading">Kintail</h2>
      <p className="walk-text">Kintail is a fabulous place for hill walking.  It is the area surrounding Glen Shiel and has many famous 
                                mountains including the Five Sisters, the Saddle and the South Glen Shiel Ridge to name but a few.  For those who
                                enjoy their hillwalking explore the walkhighlands link below to get some great routes.
      </p>                                            
    </div>
  );
}

export default Kintail
